import React from "react";
import { SOBRE, COOPERACAO } from "@/content/site";
import { Container, Eyebrow, Body, ArrowLink, Reveal } from "@/components/site/ui";
import ContactForm from "@/components/site/ContactForm";

// Sobre + Cooperação + Contato, numa única seção final.
export const SobreContato = () => (
    <section id="contato" data-testid="home-contato" data-section-id="contato" className="relative bg-[#0E2018] py-24 md:py-32 scroll-mt-20 border-t border-[#1B3025]">
        <Container className="grid grid-cols-1 lg:grid-cols-12 gap-14">
            <Reveal className="lg:col-span-5 flex flex-col gap-12">
                <div data-testid="home-sobre" data-section-id="sobre">
                    <Eyebrow>{SOBRE.eyebrow}</Eyebrow>
                    <p className="font-serif font-light text-[19px] md:text-[21px] leading-[1.6] text-[#F2EFE5]">{SOBRE.curta}</p>
                    <div className="mt-6">
                        <ArrowLink to="/sobre" testId="home-sobre-link">Sobre</ArrowLink>
                    </div>
                </div>
                <div className="pt-10 border-t border-[#1B3025]">
                    <Eyebrow>{COOPERACAO.eyebrow}</Eyebrow>
                    <Body>{COOPERACAO.lead}</Body>
                </div>
            </Reveal>
            <Reveal className="lg:col-span-7 lg:pl-6" delay={150}>
                <p className="font-serif font-light text-[28px] md:text-[34px] text-[#F2EFE5] mb-8">{COOPERACAO.title}</p>
                <ContactForm source="home" />
            </Reveal>
        </Container>
    </section>
);
